<div class="container-fluid home-dashboard">
  <div class="spinner-container" *ngIf="!contentLoaded">
    <mat-spinner></mat-spinner>
  </div>

  <div class="row home-filter-row">
    <div class="col-12 col-xl-6 ml-auto home-filter-column">
      <app-filter-card (filterEmit)="filter($event)" [filterEmitInit]="true" (sectorListEmit)="setSectorList($event)"
        (printExcelEmit)="print($event)" [filterButtonText]="'Buscar'" class="home-filter-card">
      </app-filter-card>
    </div>
  </div>
  <div class="row justify-content-center home-stats-row">
    <div class="col-12 col-xl-8 home-stats-column">
      <mat-card class="card-home-info" *ngIf="dotacionObj">
        <mat-card-title class="text-center home-section-title"><strong>Dotación</strong></mat-card-title>
        <mat-card-content>
          <div class="row home-dotation-grid">
              <div class="col-3 text-center box-dot" matTooltip="Ver detalle"
                (click)="redirectDotacion(22, 'Dotación Inicial')">
                <p class="p-dotacion">Inicio de Periodo:</p> <span class="span-dotacion">{{ dotacionObj.dInicial
                  }}</span>
              </div>
              <div class="col-3 text-center box-dot" matTooltip="Ver detalle" (click)="redirectDotacion(24, 'Ingresos')">
                <p class="p-dotacion">Ingresos:</p> <span class="span-dotacion">{{ dotacionObj.ingresos }}</span>
              </div>
              <div class="col-3 text-center box-dot" matTooltip="Ver detalle" (click)="redirectDotacion(25, 'Bajas')">
                <p class="p-dotacion">Bajas:</p> <span class="span-dotacion">{{ dotacionObj.bajas }}</span>
              </div>
              <div class="col-3 text-center box-dot" matTooltip="Ver detalle"
                (click)="redirectDotacion(23, 'Dotación Final')">
                <p class="p-dotacion">Fin de Periodo:</p> <span class="span-dotacion">{{ dotacionObj.dFinal }}</span>
              </div>
          </div>
        </mat-card-content>
        <!-- POR AHORA OCULTOS HASTA HACER EL DESARROLLO -->
        <!-- <mat-card-actions align="end" class="mt-2">
          <button mat-stroked-button class="btn-action" matTooltip="Ver detalle" [matTooltipPosition]="'above'">
            <mat-icon>
              <span class="material-icons-outlined">
                bar_chart
              </span>
            </mat-icon>
          </button>
          <button mat-stroked-button class="btn-action" matTooltip="Ver detalle" [matTooltipPosition]="'above'"
            >
            <mat-icon>
              <span class="material-icons-outlined">
                arrow_right_alt
              </span>
            </mat-icon>
          </button>
        </mat-card-actions> -->
      </mat-card>
    </div>
  </div>
  <div class="home-lower-content">
    <div class="row justify-content-center home-dashboard-primary-row">
      <div class="col-12 col-xl-9 home-primary-column">
        <div #cardsContainer class="cards-container home-primary-cards" *ngIf="tableroCards[0]">
        <mat-card *ngFor="let itemCard of tableroCards[0]" class="card-item dashboard-card" [ngClass]="setBg(itemCard.EstadoObjeto)"
          matTooltip="{{ itemCard.ControlDesc }}">
        <mat-card-title class="text-center dashboard-card-title">{{ itemCard.Ncontrol }}</mat-card-title>
        <mat-card-content class="text-center mt-0">
          <p class="dashboard-card-value">
            <span class="dashboard-card-percent">{{ itemCard.Valor1 | number: '1.2-2' }}%</span><br>
            <span class="dashboard-card-subvalue">{{ itemCard.Valor2 }}</span><br>
            <span class="dashboard-card-theory" *ngIf="itemCard.MuestraDotacionTeorica==1"> Dotación Teórica: {{
              itemCard.DotacionTeorica }}</span>
            <!--<span style="font-size: 12px" *ngIf="itemCard.MuestraComparativos==0"> <br> </span>-->
          </p>

        </mat-card-content>
        <mat-card-actions align="end" class="mt-2">
          <button mat-stroked-button class="btn-action" matTooltip="Ver detalle" [matTooltipPosition]="'above'"
            (click)="openModalChart(itemCard, true)">
            <mat-icon>
              <span class="material-icons-outlined">
                bar_chart
              </span>
            </mat-icon>
          </button>
          <button mat-stroked-button class="btn-action" matTooltip="Ver detalle" [matTooltipPosition]="'above'"
            (click)="redirect(itemCard)">
            <mat-icon>
              <span class="material-icons-outlined">
                arrow_right_alt
              </span>
            </mat-icon>
          </button>
        </mat-card-actions>
        </mat-card>
        </div>
      </div>
    </div>

    <div class="row mr-0 home-totals-row">
      <div class="col">
        <app-swiper-cards *ngIf="tableroCards[1]" [tableroCards]="tableroCards[1]" (redirectEmit)="redirect($event)"
          (openModalEmit)="openModalChart($event, false)">
        </app-swiper-cards>
      </div>
    </div>
  </div>
</div>

<app-message [mostrarMensaje]="mensajeObj?.ActivarAlerta" [mensaje]="mensajeObj?.MensajeAlerta"></app-message>
